import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import { adminUrl } from "../../EposConfig";
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { defaultReceiptData, IReceiptData } from "../../types/IReceiptData";
import { defaultReceipt, IReceipt } from "../../types/IReceipt";
import { getReceipts } from "../../services/Service";
import { IReceiptRow } from "../../types/IReceiptRow";
import { IPrinter } from "../../types/IPrinter";

export interface IOrderHistoryProps {
  close(): void;
  show: boolean;
  showMenu(): void;
}

export const OrderHistoryModal: React.FC<IOrderHistoryProps> = (
  props: IOrderHistoryProps
): JSX.Element => {
  const today = new Date();
  const now = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 1,
    0,
    0,
    0
  );
  const to = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    23,
    59,
    1
  );

  const context = useContext(ApplicationContext);
  const [receipts, setReceipts] = useState<IReceipt[]>([]);
  const [selected, setSelected] = useState(defaultReceipt);
  const [loading, setLoading] = useState(false);
  const [showPrinterOptions, setShowPrinterOptions] = useState(false);
  const [start, setStart] = useState(now);
  const [end, setEnd] = useState(to);

  async function getReceiptData() {
    setLoading(true);
    const response = await getReceipts(
      start,
      end,
      context.AuthenticatedUser.getToken()
    );

    if (!response) {
      setLoading(false);
      return;
    }

    setReceipts(response.reverse());
    setLoading(true);
  }

  useEffect(() => {
    if (props.show === true) {
      getReceiptData();
    }
  }, [props.show]);

  function onReceiptClick(receipt: IReceipt) {
    setSelected(receipt);
  }

  const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

  function process() {
    const rows: IReceiptRow[] = selected.rows;

    context.Receipt.setRows(rows);

    sleep(2000);
    props.showMenu();
  }

  function formatDateTime(dt: Date) {
    const date = new Date(dt);
    var year = date.getFullYear(),
      month = date.getMonth() + 1, // months are zero indexed
      day = date.getDate(),
      hour = date.getHours(),
      minute = date.getMinutes(),
      second = date.getSeconds(),
      hourFormatted = hour % 12 || 12, // hour returned in 24 hour format
      minuteFormatted = minute < 10 ? "0" + minute : minute,
      morning = hour < 12 ? "am" : "pm";

    return day + "/" + month + "/" + year + " " + hour + ":" + minute;
  }

  function isSelected(r: IReceipt) {
    if (selected.id === r.id) {
      return true;
    }
    return false;
  }

  function onPrinterClick(printer: IPrinter) {
    const printerOptions = printer.name.split(":");

    let printers: IPrinter[] = [];

    const availablePrinters = context.Configuration.getSettings().printers;

    printerOptions.forEach((additionalPrinter) => {
      availablePrinters.forEach((p) => {
        const pValues = p.name.split(":");
        if (pValues[0] === additionalPrinter) {
          printers.push(p);
        }
      });
    });

    print(printers);
    setShowPrinterOptions(false);
  }

  async function print(printers: IPrinter[]) {
    const selectedReceipt = selected;
    selectedReceipt.printerSettings = printers;

    const receiptData: IReceiptData = {
      receipt: selectedReceipt,
      token: context.AuthenticatedUser.getToken(),
      tableUuid: "",
    };

    if (printers.length > 0) {
      const receiptJson = JSON.stringify(receiptData);
      var encodedStringBtoA = btoa(receiptJson);

      let url = "https://print.waepos.com/Default.aspx?id=" + selected.id;
      url += "&data=" + encodedStringBtoA;

      window.location.href = url;
    }
  }

  function printerName(printer: IPrinter) {
    const values = printer.name.split(":");
    return values[0];
  }

  function onAllPrinterClick() {
    print(context.Configuration.getSettings().printers);
    setShowPrinterOptions(false);
  }

  function onNonePrinterClick() {
    print([]);
    setShowPrinterOptions(false);
  }

  const printOptionsModal = (): JSX.Element => {
    return (
      <>
        <Modal
          show={showPrinterOptions}
          onHide={() => setShowPrinterOptions(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Print ?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ float: "left" }}>
              {context.Configuration.getSettings()
                .printers.sort((a, b) => (a.position > b.position ? 1 : -1))
                .map((p) => (
                  <div style={{ padding: 10, float: "left" }}>
                    <Button
                      variant="primary"
                      style={{
                        width: 150,
                        height: 100,
                        fontWeight: "bolder",
                        borderRadius: "10px",
                        fontSize: 16,
                      }}
                      onClick={() => onPrinterClick(p)}
                      key={p.id}
                    >
                      {printerName(p)}
                    </Button>
                  </div>
                ))}
            </div>

            {context.Configuration.getSettings().printers.length > 1 ? (
              <div style={{ padding: 10, float: "left" }}>
                <Button
                  variant="primary"
                  style={{
                    width: 100,
                    height: 100,
                    fontSize: "16px",
                    fontWeight: "bolder",
                  }}
                  onClick={() => onAllPrinterClick()}
                >
                  All
                </Button>
              </div>
            ) : (
              <></>
            )}

            <div style={{ padding: 10, float: "left" }}>
              <Button
                variant="primary"
                style={{
                  width: 100,
                  height: 100,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => onNonePrinterClick()}
              >
                No print
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <Button
              variant="secondary"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => {
                setShowPrinterOptions(false);
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  const content = () => (
    <>
      <Table selectable>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>Created At</TableHeaderCell>
            <TableHeaderCell>Customer Receipt No</TableHeaderCell>
            <TableHeaderCell>Id</TableHeaderCell>
            <TableHeaderCell>Total</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <Table.Body>
          {receipts.map((r) => (
            <Table.Row
              onClick={() => {
                onReceiptClick(r);
              }}
              active={isSelected(r)}
            >
              <Table.Cell width={5} height={60}>
                {formatDateTime(r.createdAt)}
              </Table.Cell>
              <Table.Cell>{r.customerReceiptNumber}</Table.Cell>
              <Table.Cell>{r.id}</Table.Cell>
              <Table.Cell>£{r.total.toFixed(2)}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );

  const historyModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Order History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{ height: "60vh", overflowY: "auto", overflowX: "hidden" }}
            >
              {content()}
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <Button
              variant="primary"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => setShowPrinterOptions(true)}
            >
              Re-Print
            </Button>
            <Button
              variant="primary"
              style={{
                width: 100,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => process()}
            >
              Re-Order
            </Button>
            <Button
              variant="success"
              style={{
                width: 150,
                height: 50,
                fontSize: "16px",
                fontWeight: "bolder",
              }}
              onClick={() => props.close()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{historyModal()}</>
      <>{printOptionsModal()}</>
    </>
  );
};
